import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@/lib/firebase/config'
import type { Agency } from '@/types'

export function useAgencyProfile(agencyId?: string | null) {
  const [agency, setAgency] = useState<Agency | null>(null)
  const [isLoading, setIsLoading] = useState(Boolean(agencyId))

  useEffect(() => {
    if (!agencyId) {
      setAgency(null)
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    const unsubscribe = onSnapshot(
      doc(db, 'agencies', agencyId),
      (snapshot) => {
        if (!snapshot.exists()) {
          setAgency(null)
          setIsLoading(false)
          return
        }

        setAgency({
          id: snapshot.id,
          ...snapshot.data(),
        } as Agency)
        setIsLoading(false)
      },
      (error) => {
        console.error('Error listening to agency profile:', error)
        setAgency(null)
        setIsLoading(false)
      }
    )

    return unsubscribe
  }, [agencyId])

  return {
    agency,
    isLoading,
  }
}
